import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';
import PledgeModel from 'donor-elf-web/models/pledge';
import { type CampaignGoalRouteModel } from '../goal';
import { type CampaignDashboardPledgesSectionItem } from 'donor-elf-web/models/campaign-goal-dashboard';

export interface PledgeSectionItem extends CampaignDashboardPledgesSectionItem {
  pledge: PledgeModel;
}

export default class CampaignGoalExpectingRoute extends Route {
  @service declare contactsCache: any;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  async model() {
    let campaignGoalModel = this.modelFor(
      'funds.fund.campaigns.campaign.goals.goal',
    ) as CampaignGoalRouteModel;
    let pledgeSections =
      campaignGoalModel.campaignGoal.campaignGoalDashboard!.pledges;
    let expectedPledgeIds: string[] =
      pledgeSections.expecting.map(e => e.pledge_id.toString()) || [];
    // let noGiftsPledgeIds: string[] = pledgeSections.no_gifts?.mapBy('pledge_id') || [];
    // let overduePledgeIds: string[] = pledgeSections.overdue?.mapBy('pledge_id') || [];
    let pledgeIds = [...expectedPledgeIds]; //, ...noGiftsPledgeIds, ...overduePledgeIds];

    let pledges: PledgeModel[] = [];
    if (pledgeIds.length > 0) {
      pledges = (
        await this.store.query('pledge', { filter: { id: pledgeIds } })
      ).slice();
    }
    let pledgesById: { [pledgeId: string]: PledgeModel } = {};
    let pledgesByContactId: { [contactId: string]: PledgeModel[] } = {};
    for (let pledge of pledges) {
      pledgesById[pledge.id] = pledge;
      if (pledgesByContactId[pledge.contactId!] == null) {
        pledgesByContactId[pledge.contactId!] = [];
      }
      pledgesByContactId[pledge.contactId!].push(pledge);
    }

    let expectingItemsByContactId: { [contactId: string]: any[] } = {};
    for (let expectingItem of pledgeSections.expecting) {
      let pledge = pledgesById[expectingItem.pledge_id];
      // technically this shouldn't happen, but it's possible that the pledge
      // was deleted and the dashboard wasn't updated yet
      if (pledge) {
        let item = {
          ...expectingItem,
          pledge,
        };
        if (expectingItemsByContactId[pledge.contactId!] == null) {
          expectingItemsByContactId[pledge.contactId!] = [];
        }
        expectingItemsByContactId[pledge.contactId!]?.push(item);
      }
    }
    let contactExpectingItems: any[] = [];
    for (let contactId of Object.keys(expectingItemsByContactId)) {
      let items = expectingItemsByContactId[contactId] || [];

      contactExpectingItems.push({
        contact: this.contactsCache.contactsById[contactId],
        contactId,
        expectingItems: sortByProperties(items, ['expected_amount:desc']),
        totalExpecting: items
          .map((x) => x.expected_amount)
          .reduce((x, y) => x + y, 0),
      });
    }

    return {
      ...campaignGoalModel,
      contactExpectingItems,
    };
  }
}
